<template>
  <div>
    <el-row class="tac">
      <el-col>
        <!-- <div  class="menuTitleStyle"><h5>菜单</h5></div> -->

        <el-menu :default-active="$route.path" :collapse="false" class="el-menu-vertical-demo" @select="handleSelect"
          @open="handleOpen" @close="handleClose" :default-openeds="openeds" router>

<!--          <el-submenu index="3" v-show="helpShow()">
            <template slot="title">
              <i class="el-icon-location"></i>
             <span style="font-weight: bold;font-size: 18px;">运营管理</span>
            </template>
            <el-menu-item index="/competition_list">活动管理</el-menu-item>
          </el-submenu> -->

          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-search"></i>
              <span style="font-weight: bold;font-size: 18px;">发布成绩单</span>
            </template>
            <el-tooltip class="item" effect="dark" content="第一次用必须看,可以少走很多弯路!" placement="right">
              <el-menu-item index="/read_me"><span style="color:red;font-weight: bold;">0.发布成绩必读</span></el-menu-item>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="需要一列一列选择科目名称,适用标准科目或列较少成绩单,或者增补修订学生成绩" placement="right">
              <el-menu-item index="/exam_import_anyfile">1.导入成绩单(新手|增补成绩)</el-menu-item>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="直接将表头按照科目导入,适用于非标准科目或列很多成绩单" placement="right">
              <el-menu-item index="/exam_import_anyfile_ex">2.导入成绩单(高手|快速导入)</el-menu-item>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="管理成绩单" placement="right">
              <el-menu-item index="/exam_list">3.管理所有成绩单</el-menu-item>
            </el-tooltip>

          </el-submenu>


          <el-submenu index="10">
            <template slot="title">
              <i class="el-icon-mobile-phone"></i>
              <span style="font-weight: bold;font-size: 18px;">修改查询界面</span>
            </template>
            <el-tooltip class="item" effect="dark" content="设计我的手机端查询界面" placement="right">
              <el-menu-item index="/search_condition">设计手机查询界面</el-menu-item>
            </el-tooltip>

          </el-submenu>


          <el-submenu index="8">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span style="font-weight: bold;font-size: 18px;">多科合并成绩单</span>
            </template>

            <el-tooltip class="item" effect="dark" content="了解合并成绩单用途,少走弯路" placement="right">
              <el-menu-item index="/merge_exam_read_me"><span style="color:red;font-weight: bold;">0.合并成绩必读</span></el-menu-item>
            </el-tooltip>


            <el-tooltip class="item" effect="dark" content="各科老师录入自己的成绩单,然后用这个工具汇总成一个成绩单" placement="right">
              <el-menu-item index="/team_exam_list">1.单科并入总表</el-menu-item>
            </el-tooltip>

          </el-submenu>



          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span style="font-weight: bold;font-size: 18px;">学生花名册</span>
            </template>
            <el-tooltip class="item" effect="dark" content="手机端誊录成绩可以加快速度." placement="right">
              <el-menu-item index="/student_list">1.手机端现在显示的名册</el-menu-item>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="导入常用花名册,年级,班级的方便下载到手机端使用." placement="right">
              <el-menu-item index="/team_students_group_list">2.全部的学生花名册</el-menu-item>
            </el-tooltip>
          </el-submenu>



          <el-submenu index="15">
            <template slot="title">
              <i class="el-icon-mobile-phone"></i>
              <span style="font-weight: bold;font-size: 18px;">加入公众号</span>
            </template>
            <el-tooltip class="item" effect="dark" content="加入到学校公众号,统一发布成绩和查询入口" placement="right">
              <el-menu-item index="/add_to_menu">链接到公众号菜单</el-menu-item>
            </el-tooltip>

          </el-submenu>

          <el-submenu index="11">
            <template slot="title">
              <i class="el-icon-s-operation"></i>
              <span style="font-weight: bold;font-size: 18px;">学科管理</span>
            </template>
            <el-tooltip class="item" effect="dark" content="检查要导入的科目是不是存在,需要添加科目点这里." placement="right">
              <el-menu-item index="/courses_list">管理学科科目</el-menu-item>
            </el-tooltip>
          </el-submenu>


          <el-submenu index="22">
            <template slot="title">
              <i class="el-icon-s-operation"></i>
              <span style="font-weight: bold;font-size: 18px;">系统设置</span>
            </template>
            <el-tooltip class="item" effect="dark" content="检查要导入的科目是不是存在,需要添加科目点这里." placement="right">
              <el-menu-item index="/short_message_setting">短信提醒</el-menu-item>
            </el-tooltip>
          </el-submenu>

          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-service"></i>
              <span style="font-weight: bold;font-size: 18px;">使用帮助</span>
            </template>
            <el-menu-item index="/connect_service">联系客服</el-menu-item>
          </el-submenu>





        </el-menu>
      </el-col>

    </el-row>
    <el-row>
      <el-divider></el-divider>
    </el-row>

  </div>

</template>

<script>
  export default {
    name: 'MenuList',
    data: function() {
      return {
        openeds: ['1'],
        username: ''
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath)
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath)

        //
        if (key === '1-0') {
          console.log('使用必读')
          this.$router.push('/read_me')
        } else if (key === '1-1') {
          console.log('成绩单')
          this.$router.push('/exam_list')
        } else if (key === '1-2') {
          this.$router.push('/exam_import_anyfile')
        } else if (key === '1-3') {
          this.$router.push('/courses_list')
        } else if (key === '2-1') {
          this.$router.push('/student_list')
        } else if (key === '2-2') {
          this.$router.push('/student_import_anyfile')
        } else if (key === '3-1') {
          this.$router.push('/help_list')
        } else if (key === '4-1') {
          this.$router.push('/connect_service')
        } else if (key === '5-1') {
          this.$router.push('/goods_list')
        } else if (key === '10-1') {
          this.$router.push('/search_condition')
        }else if(key === '15-1'){
         this.$router.push('/add_to_menu')
        }
      },
      helpShow() {
        console.log('用户名' + this.username)
        if (this.username == 'admin' || this.username=='18919312185') {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>

<style>
  .menuTitleStyle {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu.vue